var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1266"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1266"
    },
    "bundlingPackage": "data-privacy-request-ui",
    "bundlingPackageVersion": "static-1.5911",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};